import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import image from "../assets/images/background.png";
import axiosInstance from "./AxiosInstance";
import { jwtDecode } from "jwt-decode";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Gosvea
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignInSide() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = React.useState("");

  React.useEffect(() => {
    const role = localStorage.getItem("role");
    if (role) {
      // 更新页面或组件的显示内容，基于角色
      setUserRole(role);
    }
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const icpiename = data.get("icpiename");
    const password = data.get("password");
    //console.log("Login details:",icpiename,password)
    try {
      // 清理旧的 token 和角色
      localStorage.removeItem("token");
      localStorage.removeItem("role");

      const response = await axiosInstance.post(
        "/icpie/login",
        {
          icpiename: icpiename,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data;
      //console.log("result:",result);

      // 登录成功后的处理逻辑，例如保存JWT令牌
      if (result.code === 0) {
        localStorage.setItem("token", result.data);
        // console.log("Stored Token in localStorage:", result.data);
        // 解析 JWT 获取角色信息
        const decoded = jwtDecode(result.data); // 解析 JWT
        //console.log("Decoded token:", decoded);
        const role = decoded.claims.role; // 获取角色信息
        setUserRole(role);
        // 将角色存储在 localStorage 中
        localStorage.setItem("role", role);
        //console.log("Role from token:", role); // 打印角色信息
        //alert("Login successfully");

        navigate("/dashboard");
      } else {
        alert("Login failed " + result.message);
      }
    } catch (error) {
      console.error("There was a problem with the axios operation:", error);
      alert("Login failed");
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${image})`,
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="icpiename"
                label="Icpie Name"
                name="icpiename"
                autoComplete="icpiename"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
